import { render, staticRenderFns } from "./Attributes-modal.vue?vue&type=template&id=4972a45a&scoped=true"
import script from "./Attributes-modal.vue?vue&type=script&lang=js"
export * from "./Attributes-modal.vue?vue&type=script&lang=js"
import style0 from "./Attributes-modal.vue?vue&type=style&index=0&id=4972a45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972a45a",
  null
  
)

export default component.exports